/**
 * @group Components
 * @summary <blockquote>FullPageLoading component for showing a loading state that takes up the full page/screen.</blockquote>
 * @example
 * ```tsx
 * <FullPageLoading loadingText="Initializing..." />
 * ```
 */
export function FullPageLoading({ 
  loadingText = "Loading..." 
}: {
  loadingText?: string 
}) {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <p className="text-lg">{loadingText}</p>
      </div>
    </div>
  )
} 